import addOrUpdateConversationData from './helpers/addOrUpdateConversationData';
import addOrUpdateItemData from './helpers/addOrUpdateItemData';
import { action } from 'satcheljs/lib/legacy';
/**
 * Adds or updates the row in the tableView
 * This is called whenever a data is fetched from the server and is being stored. This is also called when
 * a rowAdd or rowModified notificaiton occurs
 * @param row to add or update
 * @param tableView to be loaded
 * @param state the AddOrUpdateRowDataState
 */
export default action('addOrUpdateRowData')(function addOrUpdateRowData(row, tableView) {
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            addOrUpdateConversationData(row, tableView);
            break;
        case 1 /* Message */:
            addOrUpdateItemData(row, tableView);
            break;
    }
});
//# sourceMappingURL=addOrUpdateRowData.js.map